module.exports = __webpack_public_path__ + "static/media/right-pagination.76d351be.svg";